import Vue from 'vue'
import XkSvgIcon from '@/components/XkSvgIcon' // svg组件
// 注册为全局组件
Vue.component('XkSvgIcon', XkSvgIcon)
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)